<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item prop="deptName">
      <el-input clearable placeholder="请选择工作单位" v-model="deptName" @focus="showDeptModal" @clear="clearDepts">
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-input prefix-icon="el-icon-search" v-model="filters.userName" placeholder="姓名"></el-input>
    </el-form-item>
    <el-form-item class="m-l-14">
      <load-select style="width: 280px" v-model="filters.lectureId" dictLabel="selectLectureName" dictValue="uuid"
        :data="topicList" :page="page" :hasMore="hasMore" :request="getTopicPage" @change="changeTopic" :isInit="isInit"
        :placeholder="topicPlacehodler" />
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
    <SingleCheckTree ref="deptTree" :defaultCheckedKeys="defaultCheckedKeys" :showModal="deptDialog"
      @deptSelected="selectDept" showTooltip/>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import SingleCheckTree from "@/components/tree/singleCheckTree.vue";
import LoadSelect from "@/components/load-select/index.vue";
import { getTopicLectureSearchList } from "@/api/topicLecture";

export default {
  name: "search",
  components: {
    butn,
    SingleCheckTree,
    LoadSelect
  },
  props: {
    lectureTypes: {
      type: Array,
      default: () => []
    },
    topicPlacehodler: {
      type: String,
      default: "请选择"
    },
  },
  data() {
    return {
      size: "small",
      filters: {
        deptIds: [],
        // isQueryExceed: false,
      },
      deptName: "",
      deptDialog: {
        flag: false,
      },
      defaultCheckedKeys: [],
      lectureTypeList: [],
      topicList: [],
      page: 1,
      hasMore: true,
      isInit: true,

    };
  },
  created() {
    const emptyObj = Object.create(null);
    this.filters = emptyObj;

    // this.getSysParamByTypes(["TOPIC_LECTURE_TYPE"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["TOPIC_LECTURE_TYPE"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.lectureTypeList = res.data["TOPIC_LECTURE_TYPE"] || [];
      });
    },
    initData() {
      //查询
      let params = {
        ...this.filters,
      };
      // params.isQueryExceed = params.isQueryExceed ? 1 : 0;
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {
        // isQueryExceed: false,
      };
      this.deptName = "";
      this.clearDepts();
      this.$emit("search", { t: new Date().getTime() });
    },
    checkChange() {
      this.initData();
    },
    showDeptModal() {
      this.deptDialog.flag = true;
      this.$nextTick(() => {
        this.$refs.deptTree.$refs["deptTree"]?.setCheckedKeys(this.defaultCheckedKeys);
      })
    },

    // 工作单位选择确定
    selectDept(dept) {
      this.deptName = dept.deptName;
      this.filters.deptLevelCodeQuery = dept.deptLevelCode;
      this.defaultCheckedKeys = [dept.uuid];
      this.deptDialog.flag = false;
    },

    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters.deptLevelCodeQuery = "";
      this.$nextTick(() => {
        this.$refs.deptTree.$refs["deptTree"]?.setCheckedKeys(this.defaultCheckedKeys);
      })
    },

    getTopicPage({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getTopicLectureSearchList({ page, name: keyword, lectureTypes: this.lectureTypes })
          .then(({ code, data = [] }) => {
            if (code !== 0) return;
            if (more) {
              this.topicList = [...this.topicList, ...data];
            } else {
              this.topicList = data;
            }
            this.hasMore = data.length === 10;
            this.page = page;            
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },


    changeTopic(e) {
      this.isInit = false;
      const topicItem = this.topicList.find(item => item.uuid === e);
      this.$emit("changeTopic", topicItem)
    },


    // getlectureTypesByType() {
    //   switch (this.type) {
    //     case 1:
    //       this.lectureTypes = [1,2]
    //       break;
    //     case 2:
    //       this.lectureTypes = [3]
    //       break;
    //     case 3:
    //       this.lectureTypes = [4]
    //       break;
    //   }
    // },
  },
};
</script>
